import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useLazyLoadImage } from 'tmt-ui-kit';

import { path } from '~/utils/media';

const ImageContainer = styled.div`
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
`;

const Image = styled.img`
  max-width: 100%;
  width: ${props => `${props.size.value}${props.size.unit}`};
  transition: ${props => props.theme.imageTransition};
  opacity: 0;
`;

const ImageTopic = ({ data }) => {
  const { image, size } = data;
  const ref = useRef();
  useLazyLoadImage(ref);
  return (
    <ImageContainer>
      <Image
        ref={ref}
        src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="
        data-src={path(image, 'imageTopic')}
        data-srcSet={`${path(image, 'imageTopic2x')}`}
        alt={data.image_alt || ''}
        size={size}
      />
    </ImageContainer>
  );
};

ImageTopic.propTypes = {
  data: PropTypes.object,
};

export default ImageTopic;
